import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Printer } from 'lucide-react';
export function Footer() {
  return <footer className="bg-sandev-card border-t border-sandev-border pt-16 pb-8" data-id="element-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-16">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1" data-id="element-17">
            <Link to="/" className="flex items-center gap-3 mb-6" data-id="element-18">
              <div className="w-8 h-8 rounded overflow-hidden bg-sandev-bg border border-sandev-border flex items-center justify-center" data-id="element-19">
                <img src="https://cdn.magicpatterns.com/uploads/rmRVKZFYhXZrX1RFCfWxiS/SanDev_Logo_v5.png" alt="SanDev Logo" className="w-full h-full object-contain" data-id="element-20" />
              </div>
              <span className="font-bold text-lg tracking-tight text-sandev-text" data-id="element-21">
                SanDev<span className="text-sandev-accent" data-id="element-22">.</span>
              </span>
            </Link>
            <p className="text-sandev-muted text-sm leading-relaxed mb-6" data-id="element-23">
              Industrial-grade 3D printing and prototyping services. Making
              rapid iteration accessible and affordable for modern
              manufacturing.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-24">
            <h3 className="text-sandev-text font-semibold mb-4" data-id="element-25">Quick Links</h3>
            <ul className="space-y-3" data-id="element-26">
              <li data-id="element-27">
                <Link to="/" className="text-sandev-muted hover:text-sandev-accent text-sm transition-colors" data-id="element-28">
                  Home
                </Link>
              </li>
              <li data-id="element-29">
                <Link to="/about" className="text-sandev-muted hover:text-sandev-accent text-sm transition-colors" data-id="element-30">
                  About Us
                </Link>
              </li>
              <li data-id="element-31">
                <Link to="/materials" className="text-sandev-muted hover:text-sandev-accent text-sm transition-colors" data-id="element-32">
                  Materials Guide
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-33">
            <h3 className="text-sandev-text font-semibold mb-4" data-id="element-34">Services</h3>
            <ul className="space-y-3" data-id="element-35">
              <li className="text-sandev-muted text-sm flex items-center gap-2" data-id="element-36">
                <span className="w-1.5 h-1.5 rounded-full bg-sandev-accent" data-id="element-37"></span>
                CAD Design
              </li>
              <li className="text-sandev-muted text-sm flex items-center gap-2" data-id="element-38">
                <span className="w-1.5 h-1.5 rounded-full bg-sandev-accent" data-id="element-39"></span>
                FDM Printing
              </li>
              <li className="text-sandev-muted text-sm flex items-center gap-2" data-id="element-40">
                <span className="w-1.5 h-1.5 rounded-full bg-sandev-accent" data-id="element-41"></span>
                High-Detail Resin
              </li>
              <li className="text-sandev-muted text-sm flex items-center gap-2" data-id="element-42">
                <span className="w-1.5 h-1.5 rounded-full bg-sandev-accent" data-id="element-43"></span>
                Rapid Prototyping
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-44">
            <h3 className="text-sandev-text font-semibold mb-4" data-id="element-45">Contact</h3>
            <ul className="space-y-4" data-id="element-46">
              <li className="flex items-start gap-3 text-sandev-muted text-sm" data-id="element-47">
                <Mail size={16} className="text-sandev-accent mt-0.5 shrink-0" data-id="element-48" />
                <span data-id="element-49">Terran@sandevindustries.com</span>
              </li>
              <li className="flex items-start gap-3 text-sandev-muted text-sm" data-id="element-50">
                <Phone size={16} className="text-sandev-accent mt-0.5 shrink-0" data-id="element-51" />
                <span data-id="element-52">1-226-505-1514</span>
              </li>
              <li className="flex items-start gap-3 text-sandev-muted text-sm" data-id="element-53">
                <MapPin size={16} className="text-sandev-accent mt-0.5 shrink-0" data-id="element-54" />
                <span data-id="element-55">Kitchener Ontario, Canada</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-sandev-border pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-56">
          <p className="text-sandev-muted text-sm" data-id="element-57">
            © {new Date().getFullYear()} SanDev Industries. All rights
            reserved.
          </p>
          <div className="flex items-center gap-2 text-sandev-muted text-sm" data-id="element-58">
            <Printer size={14} data-id="element-59" />
            <span data-id="element-60">Precision in every layer.</span>
          </div>
        </div>
      </div>
    </footer>;
}